import React from 'react'
import { Label, Checkbox } from '@pcln/horizon'
import { Discount } from 'pcln-icons'

type BundleOption = {
  id: string
  name: string
  label: string
  value: string
  type: string
}

type HorizonBundleAndSaveProps = {
  options?: BundleOption[]
  checkedValues: { [key: string]: boolean }
  onSelectionChange: (
    updatedTripType: string,
    checked: boolean,
    optionValue: string
  ) => void
  label?: string
  className?: string
  tripType: string
}

const defaultOptions: BundleOption[] = [
  {
    id: 'addFlights',
    name: 'addFlights',
    label: 'Add Flights',
    value: 'FLY',
    type: 'FLY'
  },
  {
    id: 'addCar',
    name: 'addCar',
    label: 'Add Car',
    value: 'DRIVE',
    type: 'DRIVE'
  }
]

export default function HorizonBundleAndSave({
  options = defaultOptions,
  checkedValues,
  onSelectionChange,
  label = 'Package Deals',
  className = '',
  tripType
}: HorizonBundleAndSaveProps) {
  function getUpdatedTripType(checked: boolean, option: BundleOption) {
    return checked
      ? `${tripType}:${option.type}`
      : tripType.replace(`:${option.type}`, '')
  }

  return (
    <div className={`flex flex-row gap-2 ${className}`}>
      <div className="flex items-center gap-2">
        <Discount size={24} color="success" />
        <span className="text-sm font-medium text-success-dark">{label}</span>
      </div>
      <div className="flex flex-row gap-2">
        {options.map(option => {
          const checked = checkedValues[option.value] || false
          return (
            <Label
              key={option.id}
              htmlFor={option.id}
              className="flex items-center"
            >
              <Checkbox
                id={option.id}
                value={option.value}
                name={option.name}
                checked={checked}
                handleChange={() => {
                  const newCheckedState = !checked
                  const updatedTripType = getUpdatedTripType(
                    newCheckedState,
                    option
                  )
                  onSelectionChange(
                    updatedTripType,
                    newCheckedState,
                    option.value
                  )
                }}
              />
              <span className="ml-2 text-sm">{option.label}</span>
            </Label>
          )
        })}
      </div>
    </div>
  )
}
